export function peelYamiData(raw: unknown): Record<string, unknown> {
  let cur: unknown = raw;
  for (let depth = 0; depth < 6; depth += 1) {
    if (!cur || typeof cur !== 'object') return {};
    const r = cur as Record<string, unknown>;
    if (
      r.ok === true &&
      r.data != null &&
      typeof r.data === 'object' &&
      !Array.isArray(r.data)
    ) {
      cur = r.data;
      continue;
    }
    break;
  }
  return (cur && typeof cur === 'object' ? cur : {}) as Record<string, unknown>;
}
